window.getWordForm = function (number, forms) {
	if (number > 0) {
		const lastTwo = Math.trunc(Math.abs(number)) % 100;
		const last = lastTwo % 10;

		if (lastTwo > 10 && lastTwo < 20) {
			return forms[2];
		}
		if (last > 1 && last < 5) {
			return forms[1];
		}
		if (last === 1) {
			return forms[0];
		}
	}

	return forms[2];
};

window.number_format = function (number, decimals = 0, dec_point = '.', thousands_sep = ',') {
	let sign = number < 0 ? '-' : '';

	let s_number = Math.abs(parseInt(number = (+number || 0).toFixed(decimals))) + "";
	let len = s_number.length;
	let tchunk = len > 3 ? len % 3 : 0;

	let ch_first = (tchunk ? s_number.substr(0, tchunk) + thousands_sep : '');
	let ch_rest = s_number.substr(tchunk)
		.replace(/(\d\d\d)(?=\d)/g, '$1' + thousands_sep);
	let ch_last = decimals ?
		dec_point + (Math.abs(number) - s_number)
			.toFixed(decimals)
			.slice(2) : '';

	return sign + ch_first + ch_rest + ch_last;
};

window.output_money = function (money) {
	return number_format(money, 0, ' ', ' ') + ' руб.';
};
window.output_roubles = function (money) {
	return number_format(money, 0, ' ', ' ') + ' ₽';
};

window.output_money_decimal = function (money) {
	return number_format(money, 2, '.', ' ') + ' ₽';
};

window.extendsFormParams = function (params, append) {
	let resultParams = params;

	for (let name in append) {
		if (typeof append[name]['name'] !== 'undefined') {
			resultParams.push(append[name]);
		} else {
			resultParams.push({name: name, value: append[name]});
		}
	}

	return resultParams;
};

window.getFormData = function ($form) {
	let unindexed_array = $form.serializeArray();
	let indexed_array = {};

	$.map(unindexed_array, function (n, i) {
		indexed_array[n['name']] = n['value'];
	});

	return indexed_array;
};
